<main class="flex flex-col h-screen">
  @if (!userStore.loadUser() && userStore.user() && userStore.user().id !== -1)
  {
  <app-header-admin
    class="fixed z-20 w-full"
    *ngIf="userStore.user().admin"
  ></app-header-admin>
  <app-header
    class="fixed z-20 w-full"
    *ngIf="!userStore.user().admin"
  ></app-header>
  } @else {
  <div
    class="fixed flex flex-row items-center z-20 w-full bg-primary px-2 sm:px-6 lg:px-8 h-16"
  >
    <img src="/icons/aqualter.svg" class="w-30 h-15" />
  </div>
  }
  <div class="flex-1 pt-16">
    <router-outlet />
  </div>

  <footer class="bg-primary h-16 flex-shrink-0 relative">
    <img src="/icons/aqualter.svg" class="absolute right-6 top-4" />
  </footer>
</main>
